/* eslint-disable */
import React, { Component } from 'react'
import ClickOut from 'react-click-out'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Dropdown from '../../elements/Dropdown'
import DropdownList from '../../elements/DropdownList'

import { Wrapper } from './styles'

class ChoosePlanDropdown extends Component {
  state = {
    isOpen: false
  }

  toggleDropdownList = () => {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  closeDropdownList = () => {
    this.setState({
      isOpen: false
    })
  }

  goToPlanResume = () => {
    const { accountPlans, history } = this.props

    const planId = accountPlans.plans[0].id
    history.push(`/minha-veloe/${planId}/resumo`)
  }

  render() {
    const {
      state: { isOpen },
      props: { accountPlans }
    } = this

    const activePlanId = accountPlans && accountPlans.activePlanId
    const planList = accountPlans && accountPlans.plans

    let activePlan = {}

    if (activePlanId) {
      activePlan = planList.find(plan => activePlanId == plan.id) || {}
    } else if (planList.length > 0) {
      activePlan = planList[0]
    }

    const activePlanData = activePlan.plan || {}
    const activePlanFullName = activePlanData.category

    const isSinglePlan = planList.length <= 1

    return (
      <Wrapper isSinglePlan={isSinglePlan}>
        <ClickOut callback={this.closeDropdownList}>
          <Dropdown
            isOpen={isOpen}
            categoryLabel={isOpen ? 'Planos' : 'Plano'}
            dropdownLabel={isOpen ? 'Todos os planos' : activePlanFullName}
            headerLabelCategory={'plan'}
            onClick={isSinglePlan ? this.goToPlanResume : this.toggleDropdownList}
          />

          {!isSinglePlan && (
            <DropdownList
              options={[
                ...planList.map(accountPlan => ({
                  link: `/minha-veloe/${accountPlan.plan.id}/resumo`,
                  title: accountPlan.plan.type,
                  description: accountPlan.plan.category
                }))
              ]}
              isOpen={isOpen}
              onClose={this.toggleDropdownList}
            />
          )}
        </ClickOut>
      </Wrapper>
    )
  }
}

ChoosePlanDropdown.defaultProps = {
  accountPlans: {}
}

const mapStateToProps = state => ({
  accountPlans: state.reducer.accountPlans
})

export default connect(mapStateToProps)(withRouter(ChoosePlanDropdown))



// WEBPACK FOOTER //
// ./src/app/modules/ChoosePlanDropdown/index.js